export enum CandidateType {
    Fresher = "Fresher",
    Experience = "Experience"
  }